import { useEffect } from 'react';
import AppointmentHistorySection from '../../PageComponent/ProfilePage/AppointmentHistorySection';
import MobileProfileTopNavigation from './MobileProfileTopNavigation';
function MobileAppoinmentHistory() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
 
  return (
    <>
    <MobileProfileTopNavigation pageTitle={'Appointment History'} />
  <AppointmentHistorySection />
    </>
  );
}

export default MobileAppoinmentHistory;
